import { IconHighlightedSizeType } from '@kubit/web-ui-components/iconHighlighted/types';
import { SelectorRowDecorativeElementTypeEnum } from '../../../../../components/selectorRowV2/types/decorativeElement';
import { AvatarProfileSizeType, AvatarProfileVariantType, IconHighlightedVariantType, SelectionIndicatorSizeType, SelectionIndicatorVariantType, TextVariantType, ToggleVariant, } from '../variants';
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    rootContainer: {
        position: 'relative',
        cursor: 'pointer',
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        justify_content: 'space-between',
        width: '100%',
        gap: FOUNDATIONS.spacing_150,
        border_radius: FOUNDATIONS.radius_100,
        padding: FOUNDATIONS.spacing_150,
        focusVisible: {
            border_color: 'transparent',
            outline: `${FOUNDATIONS.color_effect_focus_100} solid ${FOUNDATIONS.border_100}`,
            outline_offset: 'unset',
            box_shadow: 'none',
        },
        ...STATE_TOKENS.rootContainer,
    },
    label: {
        color: FOUNDATIONS.color_neutral_font_50,
        ...STATE_TOKENS.label,
    },
    labelHighlighted: {
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        ...STATE_TOKENS.labelHighlighted,
    },
    description: {
        font_variant: TextVariantType.LINK_FONT_PARAGRAPH_400,
        color: FOUNDATIONS.color_neutral_font_50,
        ...STATE_TOKENS.description,
    },
    contentContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'flex-start',
        flex_grow: '1',
        ...STATE_TOKENS.contentContainer,
    },
    customContentContainer: {
        flex_grow: '1',
        ...STATE_TOKENS.customContentContainer,
    },
    decorativeElement: {
        [SelectorRowDecorativeElementTypeEnum.ICON]: {
            color: FOUNDATIONS.color_comp_forms_selectorrow_custom_icon,
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            ...STATE_TOKENS.decorativeElement?.ICON,
        },
        [SelectorRowDecorativeElementTypeEnum.ICON_HIGHLIGHTED]: {
            variant: IconHighlightedVariantType.CIRCLE_IMAGE_WITHOUT_BORDER,
            size: IconHighlightedSizeType.EXTRA_SMALL,
            ...STATE_TOKENS.decorativeElement?.ICON_HIGHLIGHTED,
        },
        [SelectorRowDecorativeElementTypeEnum.ILLUSTRATION]: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            ...STATE_TOKENS.decorativeElement?.ILLUSTRATION,
        },
        [SelectorRowDecorativeElementTypeEnum.AVATAR_PROFILE]: {
            variant: AvatarProfileVariantType.INITIALS,
            size: AvatarProfileSizeType.EXTRA_SMALL,
            ...STATE_TOKENS.decorativeElement?.AVATAR_PROFILE,
        },
    },
    selectionIndicator: {
        variant: SelectionIndicatorVariantType.DEFAULT,
        size: SelectionIndicatorSizeType.SMALL,
        ...STATE_TOKENS.selectionIndicator,
    },
    toggle: {
        variant: ToggleVariant.REGULAR,
        ...STATE_TOKENS.toggle,
    },
    input: {
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
        border_radius: FOUNDATIONS.radius_100,
        cursor: 'pointer',
        // these width and height are needed for iOS to make the input cover the entire area of the component
        // otherwise the input will be smaller than the component
        width: '100%',
        height: '100%',
        focusVisible: {
            border_color: 'transparent',
            outline: `${FOUNDATIONS.color_effect_focus_100} solid ${FOUNDATIONS.border_100}`,
            outline_offset: 'unset',
            box_shadow: 'none',
        },
        ...STATE_TOKENS.input,
    },
    checkbox: {
        ...STATE_TOKENS.checkbox,
    },
    radioButton: {
        ...STATE_TOKENS.radioButton,
    },
    fillingLabelWrapper: {},
});
//# sourceMappingURL=commonStyles.js.map